import { useState } from "react";
import { serviceIcon, rupee } from "@/lib/constants";
import { toast } from "sonner";
import { Search, Mic, X, ArrowRight } from "lucide-react";

const norm = (s) => (s || "").toLowerCase();

// Live service search with suggestions + optional voice input.
export function ServiceSearch({ services, value, onChange, onPick, placeholder }) {
    const [listening, setListening] = useState(false);
    const q = norm(value).trim();
    const results = q ? services.filter((s) => [s.name, s.category, s.description].some((f) => norm(f).includes(q))).slice(0, 6) : [];

    const submit = (e) => { e.preventDefault(); if (q) onPick(results[0]?.id); };
    const voice = () => {
        const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SR) return toast.error("Voice search isn't supported on this browser");
        const rec = new SR();
        rec.lang = "en-IN";
        rec.onresult = (ev) => onChange(ev.results[0][0].transcript);
        rec.onerror = () => toast.error("Couldn't hear that. Please try again.");
        rec.onend = () => setListening(false);
        setListening(true);
        rec.start();
    };

    return (
        <div className="relative">
            <form onSubmit={submit} className="flex items-center gap-2 rounded-2xl border border-border bg-white px-4 py-3 shadow-[0_4px_16px_rgba(0,156,149,0.05)]">
                <Search size={18} className="text-muted" />
                <input data-testid="home-search" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="flex-1 bg-transparent text-sm text-navy outline-none placeholder:text-muted" />
                {value && <button type="button" data-testid="home-search-clear" onClick={() => onChange("")} className="text-navy/40"><X size={16} /></button>}
                <button type="button" data-testid="home-search-mic" onClick={voice} className={`text-teal ${listening ? "animate-pulse" : ""}`}><Mic size={17} /></button>
            </form>
            {q && (
                <div className="absolute inset-x-0 top-full z-20 mt-2 overflow-hidden rounded-2xl border border-border bg-white shadow-xl" data-testid="home-search-results">
                    {results.length === 0 ? (
                        <button data-testid="home-search-none" onClick={() => onPick()} className="flex w-full items-center justify-between px-4 py-3.5 text-left text-sm text-navy/60">
                            No match for “{value}”. Browse all services <ArrowRight size={15} />
                        </button>
                    ) : results.map((s) => {
                        const Icon = serviceIcon(s.icon);
                        return (
                            <button key={s.id} data-testid={`home-search-result-${s.category}`} onClick={() => onPick(s.id)} className="flex w-full items-center gap-3 border-b border-border/60 px-4 py-3 text-left transition-colors last:border-0 hover:bg-aqua-light/50">
                                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-aqua-light"><Icon size={17} className="text-teal-dark" /></span>
                                <span className="flex-1"><span className="block text-sm font-bold text-navy">{s.name}</span><span className="text-xs text-navy/50">{s.price_label || (s.base_price ? rupee(s.base_price) : "")}</span></span>
                                <ArrowRight size={15} className="text-teal" />
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
